import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { CacheService } from 'src/appv2/services/cache.service';
import { CmsPageService } from 'src/appv2/services/cms-page.service';
import { LandingPageService } from 'src/appv2/services/landing-page.service';
import { urlToCacheKeyMapping } from 'src/appv2/utils/constants/discount.const';

@Component({
  selector: 'appv2-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(
    private cmsPage: CmsPageService,
    private landingPage: LandingPageService,
    private cacheService: CacheService
  ) {
    this.privacyCacheKey = urlToCacheKeyMapping[this.privacyCacheKeyName];
    if (this.privacyCacheKey) {
      const loadData = this.cacheService.getData(this.privacyCacheKey);
      if (typeof loadData !== 'undefined') {
        this.pageData = loadData;
      } else {
        this.getCmsPage(this.page);
      }
    }
  }

  page: string = 'privacy-policy';

  pageData: any;
  privacyCacheKeyName: string = 'cms-page-privacy-policy';
  privacyCacheKey: string;

  ngOnInit(): void {
    $('html, body').animate({ scrollTop: '0' }, 800);
    this.getCmsPage(this.page);
  }

  getCmsPage(page) {
    this.cmsPage.getpagelist(page).subscribe((data) => {
      this.pageData = data.data;
      this.cacheService.setData(this.privacyCacheKey, this.pageData);
      this.landingPage.isCmsPagePrivacyPolicyCalled.next(true);
    });
  }
}
